import React from "react";
import PropTypes from "prop-types";
import {
  GetIconForField,
  ParseAddToSectionItems,
} from "../form-design/form-design-util";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import { FluentButton } from "../../../../../../components/FluentUI/Fluent-Button";
import { FluentMenu } from "../../../../../../components/FluentUI/Fluent-Menu";

export const ModifyFormRightPanelItem = ({
  field,
  subForms,
  AddFieldToSection,
}) => {
  const OnSectionContextMenuClick = (e, subFormDisplayOrder, formName) => {
    AddFieldToSection(subFormDisplayOrder, field, formName);
  };

  return (
    <div className="task-type-right-panel-fields-item-container">
      <div className="task-type-right-panel-fields-item">
        <div className="task-type-right-panel-fields-item-icon">
          <FluentUiIcon
            name={GetIconForField(field.FieldType)}
            color={"#616161"}
            size={16}
          />
        </div>
        <div className="task-type-right-panel-fields-item-text">
          {field.Label}
        </div>
      </div>
      <FluentMenu
        button={
          <FluentButton
            icon={
              <FluentUiIcon name={"AddRegular"} color={"#212121"} size={18} />
            }
            onClick={() => {}}
          />
        }
        items={ParseAddToSectionItems(OnSectionContextMenuClick, subForms, field)}
      ></FluentMenu>
    </div>
  );
};

ModifyFormRightPanelItem.propTypes = {
  field: PropTypes.object,
  subForms: PropTypes.array,
  AddFieldToSection: PropTypes.func,
};
